/**
 * The one home of the word the garden's place is kept under in React Query (B98). It stands alone, with no imports,
 * so both the place's reader (api/gardenPlace gardenPlaceKey) and the freshness helper (lib/briefFreshness
 * gardenWritten, which Node's test runs) can take it without pulling in the API client.
 *
 * @module gardenPlaceKey
 */

/**
 * The first word of the garden place's React Query key: gardenPlaceKey builds the key from it, and a write that makes
 * a plant invalidates by it (gardenWritten), so Today's start doors read `started` again.
 */
export const GARDEN_PLACE_QUERY_KEY = 'garden-place';
